import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '视频分类',
    links: [
      { label: '爱液成分', path: '/category/aiye-chengfen' },
      { label: '分泌机制', path: '/category/fenmi-jizhi' },
      { label: '健康判断', path: '/category/jiankang-panduan' },
      { label: '日常护理', path: '/category/richang-huli' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', path: '/#faq' },
      { label: '使用指南', path: '/article/shiyong-zhinan' },
      { label: '内容声明', path: '/article/neirong-shengming' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                爱液视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              专业女性生理健康科普视频平台，致力于用科学、温暖的方式帮助每一位女性了解自己的身体。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-china-railway-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 爱液视频 - 版权所有 | 内容仅供科普参考，不构成医疗建议
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">备案号</a>
          </div>
        </div>
      </div>
    </footer>
  );
}